module.exports = __webpack_public_path__ + "static/img/16065C_2_R_20200318_LC.0665198.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16065C_2_R_20200318_LC.png
// module id = t02G
// module chunks = 0